import { halfPageManagerState as state } from './halfPageManagerState';
import * as consts from './halfPageManagerConstants';
import * as els from './halfPageManagerElements';

export const halfPageManagerInsertRepeaters = (): void => {
  const spotToInsert: HTMLElement | undefined = state.getElementToInsertRepeaterInto();
  const asideRootMiniplayer: HTMLElement | null = document.querySelector('aside > .miniplayer');

  if (spotToInsert) {
    // Vložíme počet bannerů dle výšky obsahu do elementu ke vložení
    for (let i = 0; i < state.getRepeaterBannerInsertCount(); i += 1) {
      spotToInsert.insertAdjacentHTML('beforeend', consts.REPEATER_CONTENT);

      // Právě vložený banner si uložíme do arraye s repeatery pro jeho snadnou manipulaci
      const currentBanners: NodeListOf<HTMLElement> = spotToInsert.querySelectorAll(
        '.sidebar-content--repeater'
      );
      const newBanner: HTMLElement = currentBanners[currentBanners.length - 1];
      state.pushToRepeaterBannerList(newBanner);

      // Zavoláme inicializaci reklamy na právě vložený banner;
      window.__cncAdsQueue = window.__cncAdsQueue || [];
      window.__cncAdsQueue.push(() => {
        window.__cncLazyLoad(newBanner.querySelector('.cnc_side_ad_position'));
      });
    }

    // Vynulujeme počet vkládaných bannerů, pro předcházení opakovanému vkládání
    state.setRepeaterBannerInsertCount(0);
  }

  // Miniplayer vložíme dovnitř ad-position--desktop
  if (asideRootMiniplayer && els.topAside && els.topBanner) {
    if (els.adPositionDesktop) {
      // Vložíme miniplayer přímo do ad-position--desktop
      els.adPositionDesktop.prepend(asideRootMiniplayer);
    } else {
      // Fallback - pokud nenajdeme ad-position--desktop, vložíme miniplayer do topBanneru
      els.topBanner.prepend(asideRootMiniplayer);
    }
  }
};
